import { get, post } from '@/http/axios';

/**
 * 获取芯片列表
 */
export function getChipModelList(params) {
  return get({
    url: '/transfer/nonRoadCemissionsChip/page',
    params,
    hasLoading: true
  });
}

/**
 * 提交芯片型号备案
 * @param {*} params
 * @returns
 */
export function submitRecord(params) {
  return get({
    url: '/transfer/nonRoadCemissionsChip/recordChip',
    params,
    hasLoading: true
  });
}

/**
 * 新增或修改芯片型号
 */
export function updateChipModel(data) {
  if (data.id) {
    return post({
      url: '/transfer/nonRoadCemissionsChip/update',
      data,
      hasLoading: true
    });
  }
  return post({
    url: '/transfer/nonRoadCemissionsChip/insert',
    data,
    hasLoading: true
  });
}

/**
 * 根据ID获取详细信息
 * @param {*} id
 * @returns
 */
export function getDetailById(id) {
  return get({
    url: '/transfer/nonRoadCemissionsChip/id',
    params: {
      id
    },
    hasLoading: true
  });
}

/**
 * 备案
 * @param {*} id
 * @returns
 */
export function recordChipModel(id) {
  return post({
    url: '/transfer/nonRoadCemissionsChip/recordChip',
    data: {
      id
    }
  });
}

/**
 * 备案结果查询
 * @param {*} id
 * @returns
 */
export function getRecordResult(id) {
  return get({
    url: '/transfer/nonRoadCemissionsChip/queryFromPlatform',
    params: {
      id
    },
    hasLoading: true
  });
}

/**
 * 芯片型号标识符申请
 * @param {*} data
 * @returns
 */
export function getChipPrefix(data) {
  return post({
    url: '/transfer/nonRoadCemissionsChip/getChipPrefix',
    data,
    hasLoading: true
  });
}

/**
 * 芯片型号标识符申请结果查询
 * @param {*} params
 * @returns
 */
export function queryChipPrefixResult(params) {
  return get({
    url: '/transfer/nonRoadCemissionsChip/queryChipPrefixResult',
    params,
    hasLoading: true
  });
}
